import { useTranslation } from '@exam-room/translations';
import { useEffect, useState } from 'react';

import { Button } from '../../../../components';

export type SubmittedContinueButtonVariant = 'questionnaire' | 'completed';

interface SubmittedContinueButtonProps {
  variant: SubmittedContinueButtonVariant;
  countdownTime?: number;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

function SubmittedContinueButton({
  variant,
  countdownTime = 30,
  onClick,
}: SubmittedContinueButtonProps) {
  const { t } = useTranslation();

  const [countdown, setCountdown] = useState(variant === 'completed' ? countdownTime : 0);
  const isCountingDown = countdown > 0;

  useEffect(() => {
    if (variant !== 'completed') return;

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [variant]);

  const translationKey = variant === 'questionnaire' ? 'examEnding.survey' : 'examEnding.continue';

  return (
    <Button
      size='lg'
      className='w-full max-w-[420px] !font-semibold'
      onClick={onClick}
      disabled={isCountingDown}
    >
      {t(translationKey, { countdown: isCountingDown ? `(${countdown}s)` : '' })}
    </Button>
  );
}

export default SubmittedContinueButton;
